import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getRoleList = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/role/list` });

  return data?.data;
};

export default getRoleList;
